import React, { useEffect, useState } from 'react';
import { PageState } from '@domain/rs/common/PageableRs';
import Pagination from '@components/common/pagination';
import { usePostCardList, usePostJobCategories } from '@repository/post';
import EventBanner from '@components/event/eventBanner';
import InfoCardList from '@components/info/list/infoList/InfoCardList';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Event = () => {
  const { data: postJobCategoryData } = usePostJobCategories();

  // 초기화 시점에 라우터내 쿼리값이 존재하는 경우 해당 값으로 초기값을 설정한다.
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [categorySns, setCategorySns] = useState<number[]>([]);
  const [pageInfo, setPageInfo] = useState<PageState | null>(null);

  const { data: cardList } = usePostCardList(true, { page: currentPage, size: 12, categorySns });

  useEffect(() => {
    if (!cardList) return;
    setPageInfo(cardList.pages[0].pages);
  }, [cardList, setPageInfo]);

  useEffect(() => {
    if (!postJobCategoryData) return;
    const categorySns = postJobCategoryData.categories
      .filter((item) => item.name.includes('이벤트'))
      .map((item) => item.sn);
    setCategorySns(categorySns);
  }, [postJobCategoryData]);

  if (!cardList) return null;

  return (
    <div className={cx('area')}>
      <EventBanner />
      <div className={cx('wrap')}>
        <div className={cx('listWrap')}>
          <InfoCardList
            page={currentPage}
            postCardSns={categorySns}
            setPageInfo={setPageInfo}
            category={categorySns[0]}
          />
        </div>

        {cardList.pages[0].posts.length > 0 && (
          <Pagination
            pagesVO={pageInfo}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isLeftOn={currentPage > 0 ?? false}
            isRightOn={currentPage + 1 < (pageInfo?.totalPages ?? 0) ?? false}
          />
        )}
      </div>
    </div>
  );
};

export default Event;
